<template>
  <div class="flex flex-col w-full h-full items-center">
    <div class="flex flex-col h-full w-full overflow-auto">
      <div class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
        <svg class="fill-current inline-block h-8 w-8 p-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z" /></svg>
        <div class="flex flex-col flex-1 p-2 text-left">
          <div class="text-sm font-bold uppercase">
            {{ user.name }}
          </div>
          <div class="text-xs font-thin font-serif lowercase">
            {{ user.email }}
          </div>
        </div>
      </div>
      <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1" @click="onSelectBranch()">
        <div class="flex flex-col flex-1 p-2 text-left">
          <div class="text-sm font-bold uppercase">
            {{ user.branch.name }}
          </div>
          <div class="text-xs font-thin font-serif lowercase">
            {{ user.branch.address }}
          </div>
        </div>
      </div>
      <div v-if="authUser.role === 'admin' && user.branch === null && branches.length > 0" class="flex flex-grow w-full items-center shadow-md px-2 my-1">
        <div class="flex flex-col flex-1 p-2 items-center justify-center">
          <div class="text-xs text-center">
            User belum memiliki cabang
          </div>
          <div class="bg-gray-400 py-1 px-2 mt-4 text-xs text-center uppercase" @click="$refs.selectBranchRef.open()">
            pilih cabang
          </div>
        </div>
      </div>
      <div v-if="authUser.role === 'admin' && user.branch === null && branches.length === 0" class="flex flex-grow w-full items-center shadow-md px-2 my-1">
        <div class="flex flex-col flex-1 p-2 items-center justify-center">
          <div class="text-xs text-center">
            Anda tidak memiliki cabang
          </div>
          <router-link to="/location/create" class="bg-gray-400 py-1 px-2 mt-4 text-xs text-center uppercase">
            buat cabang
          </router-link>
        </div>
      </div>
      <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 my-1">
        <div class="flex flex-1 p-2 justify-start text-xs uppercase">
          <router-link :to="'/user/'+user.id+'/schedule'" class="bg-gray-300 rounded-md py-1 px-2 shadow-sm mr-2">
            SCHEDULE
          </router-link>
          <router-link :to="'/user/'+user.id+'/report'" class="bg-gray-300 rounded-md py-1 px-2 shadow-sm">
            REPORT
          </router-link>
        </div>
      </div>
      <template v-if="authUser.role === 'admin'">
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Senin
            </div>
            <the-mask v-model="form.mon_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.mon_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.mon_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Selasa
            </div>
            <the-mask v-model="form.tue_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.tue_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.tue_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Rabu
            </div>
            <the-mask v-model="form.wed_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.wed_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.wed_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Kamis
            </div>
            <the-mask v-model="form.thu_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.thu_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.thu_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Jumat
            </div>
            <the-mask v-model="form.fri_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.fri_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.fri_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Sabtu
            </div>
            <the-mask v-model="form.sat_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.sat_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.sat_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="user.branch !== null" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Minggu
            </div>
            <the-mask v-model="form.sun_check_in" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.sun_check_out" mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <div class="text-sm flex-1 uppercase mx-2">
              <input v-model="form.sun_active" type="checkbox" class="w-4 h-4">
            </div>
          </div>
        </div>
        <div v-if="isSavingSuccess" class="flex flex-shrink-0 w-full self-center items-center shadow-md text-sm bg-green-500 text-white px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center uppercase">
            save complete
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="user.branch !== null && form.mon_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Senin
            </div>
            <the-mask v-model="form.mon_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.mon_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.tue_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Selasa
            </div>
            <the-mask v-model="form.tue_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.tue_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.wed_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Rabu
            </div>
            <the-mask v-model="form.wed_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.wed_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.thu_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Kamis
            </div>
            <the-mask v-model="form.thu_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.thu_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.fri_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Jumat
            </div>
            <the-mask v-model="form.fri_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.fri_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.sat_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Sabtu
            </div>
            <the-mask v-model="form.sat_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.sat_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="user.branch !== null && form.sun_active" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center">
            <div class="text-sm flex-1 font-bold uppercase text-left">
              Minggu
            </div>
            <the-mask v-model="form.sun_check_in" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
            <the-mask v-model="form.sun_check_out" readonly mask="##:##" type="text" :masked="true" placeholder="00:00" class="text-sm text-center w-16" />
          </div>
        </div>
        <div v-if="isSavingSuccess" class="flex flex-shrink-0 w-full self-center items-center shadow-md text-sm bg-green-500 text-white px-2 my-1">
          <div class="flex flex-1 p-2 items-center justify-center text-center uppercase">
            save complete
          </div>
        </div>
      </template>
      <div v-if="authUser.role === 'admin' && user.branch !== null" class="flex flex-shrink-0 w-full self-center items-center text-sm shadow-md bg-blue-700 text-white px-2 my-1">
        <a v-if="!isSaving && !isSavingSuccess" href="javascript:void(0)" class="flex flex-1 p-2 items-center justify-center text-center uppercase" @click="onSubmit">
          save
        </a>
        <div v-if="isSaving" class="flex flex-1 p-2 items-center justify-center text-center uppercase">
          loading ...
        </div>
      </div>
    </div>
    <select-branch ref="selectBranchRef" :user-id="parseFloat($route.params.id)" :project-id="authUser.project.id" @choosen="onChoosenBranch" />
  </div>
</template>
<script>
import { TheMask } from 'vue-the-mask'
import SelectBranch from '@/components/SelectBranch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Schedule',
  components: {
    TheMask,
    SelectBranch
  },
  data () {
    return {
      isLoading: false,
      isSaving: false,
      isSavingSuccess: false,
      form: {
        id: this.$route.params.id,
        user_id: null,
        project_id: null,
        branch_id: null,
        sun_check_in: '00:00',
        sun_check_out: '00:00',
        sun_active: false,
        mon_check_in: '00:00',
        mon_check_out: '00:00',
        mon_active: false,
        tue_check_in: '00:00',
        tue_check_out: '00:00',
        tue_active: false,
        wed_check_in: '00:00',
        wed_check_out: '00:00',
        wed_active: false,
        thu_check_in: '00:00',
        thu_check_out: '00:00',
        thu_active: false,
        fri_check_in: '00:00',
        fri_check_out: '00:00',
        fri_active: false,
        sat_check_in: '00:00',
        sat_check_out: '00:00',
        sat_active: false
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['authUser']),
    ...mapGetters('branch', ['branches']),
    ...mapGetters('project', ['project']),
    ...mapGetters('user', ['user'])
  },
  async mounted () {
    await this.findUser()
    await this.getSchedule()
  },
  methods: {
    ...mapActions('user', ['find']),
    ...mapActions('userSchedule', ['get', 'update']),
    onSelectBranch () {
      if (this.authUser.role === 'admin') {
        this.$refs.selectBranchRef.open()
      }
    },
    getSchedule () {
      this.isLoading = true
      const dayStart = this.$moment().format('YYYY-MM-DD 00:00:00')
      const dayEnd = this.$moment().format('YYYY-MM-DD 23:59:59')
      this.get({
        id: this.$route.params.id,
        project_id: this.authUser.project.id,
        params: {
          day_start: dayStart,
          day_end: dayEnd
        }
      }).then(response => {
        if (this.user.branch) {
          this.form.branch_id = this.user.branch.id
          this.form.sun_check_in = this.user.schedule.sun_check_in
          this.form.sun_check_out = this.user.schedule.sun_check_out
          this.form.sun_active = this.user.schedule.sun_active
          this.form.mon_check_in = this.user.schedule.mon_check_in
          this.form.mon_check_out = this.user.schedule.mon_check_out
          this.form.mon_active = this.user.schedule.mon_active
          this.form.tue_check_in = this.user.schedule.tue_check_in
          this.form.tue_check_out = this.user.schedule.tue_check_out
          this.form.tue_active = this.user.schedule.tue_active
          this.form.wed_check_in = this.user.schedule.wed_check_in
          this.form.wed_check_out = this.user.schedule.wed_check_out
          this.form.wed_active = this.user.schedule.wed_active
          this.form.thu_check_in = this.user.schedule.thu_check_in
          this.form.thu_check_out = this.user.schedule.thu_check_out
          this.form.thu_active = this.user.schedule.thu_active
          this.form.fri_check_in = this.user.schedule.fri_check_in
          this.form.fri_check_out = this.user.schedule.fri_check_out
          this.form.fri_active = this.user.schedule.fri_active
          this.form.sat_check_in = this.user.schedule.sat_check_in
          this.form.sat_check_out = this.user.schedule.sat_check_out
          this.form.sat_active = this.user.schedule.sat_active
        }
        this.isLoading = false
      }).catch(error => {
        this.isLoading = false
        console.log(error)
      })
    },
    findUser () {
      this.isLoading = true
      this.find({
        id: this.$route.params.id,
        params: {
          project_id: this.authUser.project.id
        }
      }).then(response => {
        this.isLoading = false
      }).catch(error => {
        this.isLoading = false
        console.log(error)
      })
    },
    onChoosenBranch () {
    },
    onSubmit () {
      this.isSaving = true
      this.update({
        ...this.form,
        project_id: this.authUser.project.id
      }).then(response => {
        this.isSaving = false
        this.isSavingSuccess = true
        setTimeout(() => {
          this.isSavingSuccess = false
        }, 3000)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
